import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js";
import * as ApexCharts from "apexcharts"
import "./controllers"
